const dateFormat = (value) => {
  const date = new Date(value);
  return (
    date.getDate().toString().padStart(2, "0") +
    "-" +
    (date.getMonth() + 1).toString().padStart(2, "0") +
    "-" +
    date.getFullYear()
  );
};

const getRemainigTime = (futureTime) => {
  const futureDate = new Date(futureTime);
  futureDate.setHours(23);
  futureDate.setMinutes(59);
  futureDate.setSeconds(59);
  futureDate.setMilliseconds(999);
  const currentDate = new Date();
  var diff = (futureDate.getTime() - currentDate.getTime()) / 1000;
  diff /= 60 * 60;
  return Math.abs(Math.round(diff));
};

const getExpiryDate = (createdDate, expiryPeriod, dateformat) => {
  const expiryDate = new Date(
    new Date(createdDate).getTime() + expiryPeriod * 60 * 60 * 1000
  );
  if (dateformat) {
    return getDate("DD/MM/YYYY", expiryDate);
  }
  return (
    dateFormat(expiryDate) +
      " - " +
      expiryDate.getHours() +
      ":" +
      expiryDate.getMinutes()?.toString()?.padStart(2, "0") || ""
  );
};

const getDate = (format, value) => {
  const date = (value && new Date(value)) || new Date();
  const current_date = date.getDate().toString().padStart(2, "0");
  const current_month = (date.getMonth() + 1).toString().padStart(2, "0");
  const current_year = date.getFullYear();
  switch (format) {
    case "YYYY-MM-DD":
      return current_year + "-" + current_month + "-" + current_date;
    case "DD/MM/YYYY":
      return current_date + "/" + current_month + "/" + current_year;

    default:
      break;
  }
};

const getTimeStamp = () => {
  const date = new Date();
  return `${date.getFullYear()}${(date.getMonth() + 1)
    .toString()
    .padStart(2, "0")}${date.getDate().toString().padStart(2, "0")}${date
    .getHours()
    .toString()
    .padStart(2, "0")}${date.getMinutes().toString().padStart(2, "0")}${date
    .getSeconds()
    .toString()
    .padStart(2, "0")}`;
};

export { getTimeStamp, getDate, getRemainigTime, getExpiryDate };
export default dateFormat;
